
// SVG Icon: calendar2
export default { id: "terriajs-calendar2" };
export const id = "terriajs-calendar2";
export const name = "calendar2";
